// import { Appraiser } from 'src/shared/components/icons/professions/appraiser'
// import { Attorney } from 'src/shared/components/icons/professions/attorney'
// import { Contractor } from 'src/shared/components/icons/professions/contractor'
// import { Inspector } from 'src/shared/components/icons/professions/inspector'
// import { InsuranceBroker } from 'src/shared/components/icons/professions/insurance-broker'
// import { TitleRep } from 'src/shared/components/icons/professions/title-rep'

import type { LucideIcon } from 'lucide-react'

import loanOfficer from '../../../../../components/icons/professions/loan-officer.png'
import reAgent from '../../../../../components/icons/professions/re-agent.png'
import type { Profession } from '../../../schemas/profession'

import ProfessionItem from './profession-item'

type ProfessionListProps = {
  onSelectItem: (profession: Profession) => void
  selectedProfession?: Profession | null
}

export const TEMP_PROFESSION_LIST = {
  real_estate_agent: {
    label: 'Real estate agent',
    subtitle: 'Buy, sell or lease',
    icon: () => <img src={reAgent} width={46} height={46} alt="Real Estate Agent" />,
  },
  mortgage_loan_officer: {
    label: 'Mortgage loan officer',
    subtitle: 'Purchase or refinance',
    icon: () => <img src={loanOfficer} width={43} height={43} alt="Mortgage Loan Officer" />,
  },
  // real_estate_insurance_broker: {
  //   label: 'Real estate insurance broker',
  //   icon: InsuranceBroker,
  // },
  // contractor: {
  //   label: 'Contractor',
  //   icon: Contractor,
  // },
  // real_estate_attorney: {
  //   label: 'Real estate attorney',
  //   icon: Attorney,
  // },
  // property_inspector: {
  //   label: 'Property inspector',
  //   icon: Inspector,
  // },
  // real_estate_appraiser: {
  //   label: 'Real estate appraiser',
  //   icon: Appraiser,
  // },
  // title_company_rep: {
  //   label: 'Title company rep',
  //   icon: TitleRep,
  // },
}

const ProfessionList = ({ onSelectItem, selectedProfession }: ProfessionListProps) => {
  return (
    <div className="flex max-h-[300px] flex-col gap-4 overflow-y-auto">
      {Object.entries(TEMP_PROFESSION_LIST).map(([key, value]) => (
        <ProfessionItem
          key={key}
          onClick={() => onSelectItem(key as Profession)}
          Icon={value.icon as unknown as LucideIcon}
          label={value.label}
          subtitle={value.subtitle}
          isSelected={selectedProfession === key}
        />
      ))}
    </div>
  )
}

export default ProfessionList
